import { RefreshButton } from "@sfc/ui";
import type { ComponentProps, ReactNode } from "react";

export function ReloadPageButton({
  children = "Reload page",
  variant = "default",
  ...props
}: Omit<ComponentProps<typeof RefreshButton>, "onClick">) {
  return (
    <RefreshButton
      variant={variant}
      {...props}
      onClick={() => window.location.reload()}
    >
      {children}
    </RefreshButton>
  );
}

export function ReloadPageNotice({
  children,
  signIn = false,
  required = false,
}: {
  children: ReactNode;
  signIn?: boolean;
  required?: boolean;
}) {
  return (
    <div className="flex flex-col items-start gap-3">
      <p>{children}</p>
      <ReloadPageButton variant={required ? "default" : "outline"}>
        {signIn ? "Reload and sign in" : "Reload page"}
      </ReloadPageButton>
    </div>
  );
}
